<template>
  <div id='radio'>
    <el-radio-group v-model="childValue" @input="change">
      <div v-for="option in options" class="inline-block">
        <el-tooltip :content="option.name" placement="bottom" effect="light">
          <el-radio :label="option.value" class="radio text-overflow" :disabled="option.disabled || disabled">{{ option.name }}</el-radio>
        </el-tooltip>
      </div>
    </el-radio-group>
  </div>
</template>
<style scoped>
  #radio .radio{
    width: 180px !important;
    margin-right: 15px !important;
    margin-top: 10px !important;
    margin-bottom: 5px !important;
  }
</style>
<script>
  /**
   * @param Number value 绑定值
   * @param String name 控件名
   * @param Boolean disabled 是否禁用
   * @param Array rules 表单验证规则
   * @param Array options 选项值
   */
  import modelConfig from '../../../../config/modelConfig'
  import _verify from '../../../../assets/js/verify'
  export default {
    props: ['value', 'name', 'disabled', 'rules', 'options'],
    data() {
      return {
        childValue: null
      }
    },
    created() {
      this.initData()
    },
    methods: {
      initData() {
        if (this.value) {
          this.childValue = this.value
        } else if (this.value == null) {
          this.setDefaultValue()
        } else {
          this.value = ''
        }
      },
      setDefaultValue() {
        this.childValue = ''
        _(this.options).forEach((res) => {
          if (res.is_selected) {
            this.childValue = res.value
            this.change(this.childValue)
            return
          }
        })
      },
      change(value) {
        this.$emit('input', value)
      }
    },
    watch: {
      'value'() {
        if (this.value != this.childValue) {
          this.initData()
        }
      }
    },
    mixins: [modelConfig]
  }
</script>



// WEBPACK FOOTER //
// honrayRadio.vue?0a40774a